import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
  selector: 'pt-severity-formatter-renderer',
  template: `
    <div class="badge rounded-pill" [ngClass]="'severity-' + currentValue">
      {{currentValue}}
    </div>
  `,
  styles: [`
    .severity-VERY_LOW {
      background: var(--ptVeryLow);
    }

    .severity-LOW {
      background: var(--ptLow);
    }

    .severity-MEDIUM {
      background: var(--ptMedium);
    }

    .severity-HIGH {
      background: var(--ptHigh);
    }

    .severity-VERY_HIGH {
      background: var(--ptVeryHigh);
    }

    .severity-CRITICAL {
      background: var(--ptCritical);
      color: white;
    }
  `]
})
export class SeverityFormatterRendererComponent implements ICellRendererAngularComp, IHeaderAngularComp {
  params: any;
  list: Array<string> = [];
  currentValue: string;

  agInit(params: any): void {
    this.params = params;
    this.currentValue = this.params.value;
  }

  refresh(params: ICellRendererParams): boolean;
  refresh(params: IHeaderParams): boolean;
  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }
}
